export default __webpack_public_path__ + "static/media/sample_performer.df3d2b1a.xlsx";